<template>
	<div style="padding: 0 10px">
		<ScanQuery @onQuery="queryCall" ph="输入批次包"> </ScanQuery>
		<el-card style="margin-bottom: 10px">
			<div class="washing__div--card1">
				<ImgView
					:src="productImg"
					:width="150"
					:height="150"
					v-if="productImg"
				/>
				<DescCom
					:desc="desc"
					:column="2"
					border
					fw="600"
					fs="14px"
					v-if="desc"
					style="flex-shrink: 0; flex-grow: 1; margin: 0 20px"
				>
					<template #productSku>
						<div style="display: flex; align-items: center">
							<span>{{ detail.productSku }}</span>
							<a
								target="_blank"
								style="margin-left: 5px"
								:href="detail?.productLink"
								>查看商品链接</a
							>
							<a
								v-if="productCode"
								style="margin-left: 5px"
								target="_blank"
								:href="`https://s.theckb.com/ja/goods/${productCode}`"
							>
								CKB链接
							</a>
						</div>
					</template>
				</DescCom>
			</div>
		</el-card>

		<el-card>
			<div
				slot="header"
				style="
					text-align: left;
					display: flex;
					align-items: center;
					justify-content: space-between;
				"
			>
				<span>尺寸测量(单位:cm)</span>
				<el-tag type="danger" style="margin-left: 6px" v-if="isSpecialUser"
					>客户特殊需求对应，尺寸测量请先选择商品分类，并按照参考图说明进行测量项填写</el-tag
				>
				<div style="flex: 1; text-align: right">
					<a
						v-if="detail.productMeasureVideoUrl"
						style="margin-right: 20px"
						@click="down(detail.productMeasureVideoUrl)"
						>下载视频</a
					>
				</div>
				<BatchCopySize
					:sizeList="sizeList"
					v-if="!(!canChangeSize || !detail.needMeasureFlag)"
					:productSku="detail.productSku"
					:category="category"
					:item="detail"
				/>
				<el-button
					@click="saveSize"
					type="primary"
					size="small"
					:disabled="!canChangeSize || !detail.needMeasureFlag"
					style="float: right; margin-left: 10px"
					>提交</el-button
				>
			</div>
			<div class="goods-cate" v-if="isSpecialUser">
				<span>请先选择商品分类：</span>
				<el-select
					v-model="category"
					placeholder="请选择"
					@change="changeSelect"
				>
					<el-option
						v-for="item in options"
						:key="item.value"
						:label="item.label"
						:value="item.value"
					>
					</el-option>
				</el-select>
				<a @click="openImage" v-if="category !== 'all'">参考图</a>
			</div>
			<el-descriptions
				class="margin-top size-descriptions"
				:column="4"
				size="small"
				border
				:labelStyle="{ flex: 1 }"
				:contentStyle="{ flex: 1 }"
			>
				<el-descriptions-item v-for="i in sizeList" :key="i.code" :span="1">
					<el-form class="measureForm">
						<el-form-item
							:error="
								i.value &&
								(isNaN(i.value) || Number(i.value) == 0 || Number(i.value) < 0)
									? '请输入正确的数字'
									: ''
							"
						>
							<el-input
								v-model="i.value"
								:disabled="!detail.needMeasureFlag"
							></el-input>
						</el-form-item>
					</el-form>
					<template slot="label">
						{{ i.name }}
					</template>
				</el-descriptions-item>
				<el-descriptions-item
					v-for="i in 4 - (sizeList.length % 4) === 4
						? 0
						: 4 - (sizeList.length % 4)"
					:key="i"
				></el-descriptions-item>
			</el-descriptions>
		</el-card>
		<el-dialog
			title="参考图"
			:visible.sync="dialogVisible"
			width="800px"
			:footer="null"
		>
			<div><img :src="prewImage" alt="" style="width: 100%" /></div>
		</el-dialog>
	</div>
</template>

<script>
import BatchCopySize from "../components/BatchCopySize";
import ScanQuery from "@/components/ScanQuery";
import DescCom from "@/components/DescCom";
import ImgView from "@/components/ImgView";
import { pkgDetail, pkgDetailLog } from "@/apis/abnormal";
import { editSize } from "@/apis/checking";
import { sizeList } from "./sizeList.js";
import sizeMinxin from "@/mixins/sizeMixin.js";
import { byProductSku } from "@/apis/inHouse";
export default {
	name: "QCRequire",
	components: {
		ScanQuery,
		DescCom,
		ImgView,
		BatchCopySize,
	},
	mixins: [sizeMinxin],
	data() {
		return {
			isSpecialUser: false,
			dialogVisible: false,
			prewImage: "",
			productCode: "",
			category: "all",
			detail: {},
			imgUri: "",
			query: {
				code: "",
			},
			desc: "",
			specialQC: [], // String
			AdditionalItems: [],
			annex: [],
			productImg: "",
			specialCheckRequirementImgSet: [],
			specialCheckRequirementSet: [],
			abnormalShow: false,
			ingredientList: [],
			dataSource: [],
			dataSourceFromWms: [],
			productMeasureDtoList: [],
		};
	},
	computed: {
		canChangeSize: function () {
			return this.detail?.orderCode && this.sizeList.some((v) => v.value);
		},
	},
	methods: {
		queryCall: function (payload) {
			if (payload.code) {
				this.query.code = payload.code;
				(this.specialQC = []), // String
					(this.AdditionalItems = []),
					(this.annex = []),
					(this.productImg = "");
				this.specialCheckRequirementSet = [];
				this.specialCheckRequirementImgSet = [];

				this.dataSource = [];
				(this.dataSourceFromWms = []), (this.specialCheckRequirement = []);
				this.washingLabel = true;
				this.sizes = sizeList.map((v) => {
					return {
						...v,
						value: "",
					};
				});
				this.getDetails();
			}
		},
		getDetails: function () {
			let params = {
				pkgCode: this.query.code,
			};
			pkgDetail(params).then(async ({ code, data }) => {
				if (code === 0) {
					if (data.productType == 1) {
						const res = await byProductSku({ productSku: data.productSku });
						if (res?.code == 0) {
							this.productCode = res.data?.productCode;
						}
					}
					pkgDetailLog(params);
					this.detail = data;
					this.isSpecialUser = data.sizeMeasureCustomerFlag === 1;
					this.category = data.measureCategory || "all";
					this.productMeasureDtoList = data.productMeasureDtoList ?? [];
					this.getSizeList();
					if (data.productMeasureDtoList) {
						this.sizeList = this.sizeList.map((v) => {
							return {
								...v,
								value: this.productMeasureDtoList.filter(
									(y) => y.code == v.code
								).length
									? this.productMeasureDtoList.filter(
											(y) => y.code == v.code
									  )[0].value
									: "",
							};
						});
					}
					this.productImg = data.productImg;
					this.desc = {
						pkgCode: {
							title: "批次包编码",
							value: data.pkgCode,
						},
						amount: {
							title: "批次数量",
							value: data.amount,
						},
						productProp: {
							title: "颜色尺码",
							value: data.productProp,
						},
						unificationCustomerFullName: {
							title: "客户名称",
							value: data.unificationCustomerFullName || "",
						},
						goodsName: {
							title: "商品名称",
							value: data.productName,
						},
						remark: {
							title: "备注信息",
							value: data.remark,
						},
						goodsType: {
							title: "商品类型",
							value:
								data.combinationProductItemFlag == 1
									? "组合商品子商品"
									: data.productType == 1
									? "普通商品"
									: data.productType == 2
									? "OEM商品"
									: data.productType == 3
									? "组合商品主商品"
									: "-",
						},
						productSku: {
							title: "平台SKU",
							value: data.productSku,
							sort: "productSku",
						},
					};
				}
			});
		},
		saveSize() {
			if (this.sizeList.some((v) => isNaN(v.value))) {
				this.$message.warning("尺寸必须是数字");
				return false;
			}
			if (this.sizeList.some((v) => v.value && Number(v.value) == 0)) {
				this.$message.warning("尺寸不能为0");
				return false;
			}
			if (this.sizeList.some((v) => v.value && Number(v.value) < 0)) {
				this.$message.warning("尺寸不能为负数");
				return false;
			}
			let params = {
				measureCategory: this.category === "all" ? "" : this.category,
				orderCode: this.detail.orderCode,
				list: this.sizeList
					.filter((v) => v.value)
					.map((v) => {
						return {
							...v,
							value: Number(v.value),
						};
					}),
			};
			editSize(params).then((res) => {
				if (res.code == 0) {
					this.$message.success(res.msg);
				}
			});
		},
		down(url) {
			fetch(url)
				.then((res) => res.blob())
				.then((blob) => {
					// 将链接地址字符内容转变成blob地址
					const a = document.createElement("a");
					a.href = URL.createObjectURL(blob);
					a.download = `${this.detail.platformOrderNo}_${this.detail.productSku}`; // 下载文件的名字
					document.body.appendChild(a);
					a.click();
				});
		},
	},
	mounted() {},
};
</script>

<style scoped lang="less">
.goods-cate {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	margin-bottom: 20px;

	a {
		margin-left: 20px;
	}
}

.washing__div--card1 {
	display: flex;
	justify-content: space-between;
}
</style>
<style lang="less">
.measureForm .el-form-item {
	margin-bottom: 0px;
}

.size-descriptions .el-descriptions-row {
	display: flex;

	.el-descriptions-item__cell {
		border-right: 0 !important;
		border-bottom: 0 !important;
		display: flex;
		align-items: center;
	}

	.el-descriptions-item__cell:last-child {
		border-right: 1px solid #ebeef5 !important;
	}
}

.size-descriptions tbody:last-child {
	.el-descriptions-row {
		.el-descriptions-item__cell {
			border-bottom: 1px solid #ebeef5 !important;
		}
	}
}
</style>